<header class="page-head">
  <div class="page-head__text">
    <h1 tabindex="-1">Canvas Builder tools</h1>
    <p class="page-head__desc">
      Staff tools for the catalog and for legacy conversions.
    </p>
  </div>
</header>

<div class="tools">
  @if (auth.isCatalogAdmin()) {
    <a class="tool card" routerLink="/products">
      <span class="tile"><mng-icon name="package" /></span>
      <div class="body">
        <h2>Products</h2>
        <p>
          Author the products, variants, surfaces and rules the editor builds
          on.
        </p>
      </div>
      <mng-icon class="chevron" name="chevron-right" />
    </a>
  } @else {
    <div class="tool card locked">
      <span class="tile locked"><mng-icon name="lock" /></span>
      <div class="body">
        <h2>Products</h2>
        <p>Products needs the print-spec permission on your account.</p>
      </div>
    </div>
  }

  <a class="tool card" routerLink="/conversions">
    <span class="tile"><mng-icon name="repeat" /></span>
    <div class="body">
      <h2>Conversions</h2>
      <p>Convert legacy templates and covers into editor designs.</p>
    </div>
    <mng-icon class="chevron" name="chevron-right" />
  </a>
</div>
